import * as React from "react";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import { DialogContent } from "@mui/material";

export interface ModalDialogProps {
  id: string;
  title: string;
  children?: React.ReactNode;
  cancelTitle: string;
  okTitle: string;
  showCancel?: boolean;
  showOk?: boolean;
  onCancel?: () => void;
  onOk?: () => void;
}

export const useModal = ({ defaultOpen }: { defaultOpen: boolean }) => {
  const [open, setOpen] = React.useState(defaultOpen);

  const handleCancel = () => {
    setOpen(false);
  };

  const handleOk = () => {
    setOpen(false);
  };

  const Modal: React.FC<ModalDialogProps> = ({
    id,
    onOk,
    title,
    children,
    cancelTitle,
    okTitle,
    showOk = true,
    showCancel = true,
  }) => {
    return (
      <Dialog
        id={id}
        sx={{ "& .MuiDialog-paper": { width: "80%" } }}
        // maxWidth="xs"
        open={open}
      >
        <DialogTitle>{title}</DialogTitle>

        {children ? <DialogContent dividers>{children}</DialogContent> : null}

        <DialogActions>
          {showCancel ? (
            <Button
              autoFocus
              onClick={handleCancel}
              sx={{
                fontSize: "1.5rem",
              }}
            >
              {cancelTitle}
            </Button>
          ) : null}
          {showOk ? (
            <Button
              onClick={() => {
                handleOk();
                onOk?.();
              }}
              sx={{
                fontSize: "1.5rem",
              }}
            >
              {okTitle}
            </Button>
          ) : null}
        </DialogActions>
      </Dialog>
    );
  };

  return {
    Modal,
    open,
    setOpen,
  };
};
